import { useAuth } from 'react-oidc-context';
import { PublicLayout } from '../components/Layout';

export function Home() {
  const auth = useAuth();

  return (
    <PublicLayout>
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-20 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">Knocking Forms</p>
        <h1 className="mt-4 max-w-xl text-3xl font-bold leading-tight sm:text-4xl">
          The right form, always at the same link.
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-muted">
          This is Knocking's hub for official forms. If a colleague or partner shared a form link
          with you, simply open that link — it always points to the current version.
        </p>
        <div className="mt-10 flex flex-col items-center gap-4">
          <a
            href="https://knocking.com"
            className="rounded-full bg-brand px-6 py-3 text-sm font-semibold text-brand-contrast transition-colors hover:bg-brand-strong"
          >
            Visit knocking.com
          </a>
          <button
            type="button"
            onClick={() => void auth.signinRedirect()}
            className="inline-flex items-center gap-2.5 rounded-full border border-border bg-card px-5 py-2.5 text-sm font-medium transition-colors hover:bg-input"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
              <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
              <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
              <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
              <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
            </svg>
            Sign in with Google
          </button>
          <span className="text-xs text-muted">Knocking staff only — knocking.com accounts</span>
        </div>
      </div>
    </PublicLayout>
  );
}
